import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FileSignature, PenLine } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { bsiServicePath } from './helpers';

type Props = {
  title?: string;
  reference?: string | null;
  signableCount?: number | null;
  onNewTransfer?: () => void;
  /** اگر true باشد بعد از کوتاهی خودکار به قابل‌امضا می‌رود */
  autoRedirect?: boolean;
};

const BsiTransferAwaitingSign: React.FC<Props> = ({
  title = 'ثبت شد — در انتظار امضا',
  reference,
  signableCount,
  onNewTransfer,
  autoRedirect = true,
}) => {
  const navigate = useNavigate();
  const count = signableCount ?? 0;

  const goPending = React.useCallback(() => {
    navigate(bsiServicePath('pending'));
  }, [navigate]);

  React.useEffect(() => {
    if (!autoRedirect) return;
    const t = window.setTimeout(() => goPending(), 1200);
    return () => window.clearTimeout(t);
  }, [autoRedirect, goPending]);

  return (
    <div className="mx-auto max-w-md space-y-5 py-4 text-center">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border-2 border-amber-300 bg-gradient-to-br from-amber-50 to-orange-100 shadow-inner">
        <PenLine className="h-9 w-9 text-amber-600" />
      </div>
      <div className="space-y-2">
        <p className="text-lg font-bold text-slate-900">{title}</p>
        <p className="text-sm leading-relaxed text-slate-600">
          {count > 0
            ? `${count} تراکنش برای امضای نهایی آماده است. انتقال بعد از امضا انجام می‌شود.`
            : 'برای تکمیل انتقال، به بخش قابل امضا بروید و امضا کنید.'}
        </p>
        {reference ? (
          <p className="rounded-lg bg-slate-50 px-3 py-2 font-mono text-sm font-semibold text-slate-800">
            پیگیری: {reference}
          </p>
        ) : null}
      </div>
      <div className="flex flex-col gap-2 sm:flex-row sm:justify-center">
        <Button type="button" className="bg-amber-600 hover:bg-amber-700" onClick={goPending}>
          <FileSignature className="ml-1 h-4 w-4" />
          {count > 0 ? `رفتن به قابل امضا (${count})` : 'رفتن به قابل امضا'}
        </Button>
        {onNewTransfer ? (
          <Button type="button" variant="outline" onClick={onNewTransfer}>
            انتقال جدید
          </Button>
        ) : null}
      </div>
      {autoRedirect ? <p className="text-[11px] text-slate-500">در حال هدایت به قابل امضا…</p> : null}
    </div>
  );
};

export default BsiTransferAwaitingSign;
